import React, { useState, useEffect } from "react";
import { Navbar, Nav, Container, Button, Carousel } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "../Style/Navigation.css";
import logo from "../assets/logo.png";

// Import your carousel images
import img1 from "../assets/carousel/carouselone.jpg";
import img2 from "../assets/carousel/carouseltwo.jpg";
import img3 from "../assets/carousel/carouselone.jpg";


function Navigation() {
  const [language, setLanguage] = useState("ENG");
  const [isOpen, setIsOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("home");
  const { t, i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = language === "ENG" ? "AR" : "ENG";
    setLanguage(newLang);
    i18n.changeLanguage(newLang === "ENG" ? "en" : "arr");
  };

  const toggleMenu = () => setIsOpen((prev) => !prev);
  const closeMenu = () => setIsOpen(false);

  useEffect(() => {
    const handleScroll = () => {
      const sections = ["about", "services", "products", "media", "contact"];
      const scrollPosition = window.scrollY + 100;
      for (let section of sections) {
        const el = document.getElementById(section);
        if (el) {
          const top = el.offsetTop;
          const bottom = top + el.offsetHeight;
          if (scrollPosition >= top && scrollPosition < bottom) {
            setActiveSection(section);
          }
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const sections = [
    { id: "products", label: t("Our products") },
    { id: "services", label: t("Our Services") },
    { id: "about", label: t("About Us") },
    { id: "contact", label: t("Contact Us") },
  ];

  return (
    <>
      {/* 🔹 Top Bar */}
      <Navbar className="top-bar py-4" expand="sm">
        <Container className="d-flex justify-content-between align-items-center">
          {/* Logo */}
          <Navbar.Brand href="#home" className="d-flex align-items-center">
            <img
              src={logo}
              alt="Logo"
              className="logo me-2"
              style={{ height: "50px" }}
            />
           
       <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 12px",
    position: "fixed",
    top: "0",
    right: "0",
    left: "0",
    zIndex: 1000,
    backgroundColor: "#fff",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  }}
  className="d-sm-none" // 🔸 hide entire bar on desktop
>
  {/* Left: Logo */}
  <div style={{ display: "flex", alignItems: "center" }}>
    <img
      src={logo}
      alt="Logo"
      style={{
        height: "38px",
        width: "auto",
        objectFit: "contain",
        marginRight: "6px",
      }}
    />
    <h5
      style={{
        fontSize: "15px",
        fontWeight: "600",
        color: "#b28600",
        margin: "0",
        whiteSpace: "nowrap",
      }}
    >
      Falcon Star Stamps
    </h5>
  </div>

  {/* Right: Buttons */}
  <div style={{ display: "flex", alignItems: "center" }}>
    <button
      onClick={toggleMenu}
      style={{
        fontSize: "22px",
        background: "none",
        border: "none",
        cursor: "pointer",
        color: "#333",
        marginRight: "10px",
      }}
    >
      ☰
    </button>

    <Button
      onClick={toggleLanguage}
      style={{
        fontSize: "13px",
        padding: "4px 10px",
        borderRadius: "6px",
        backgroundColor: "#b28600",
        color: "#fff",
        border: "none",
        fontWeight: "500",
      }}
    >
      {language}
    </Button>
  </div>
</div>


          </Navbar.Brand>
     

          {/* 🔹 Carousel (replaces <h1>helo</h1>) */}
          <div className=" mt-5">
            <Carousel fade interval={2500} pause={false}>
              <Carousel.Item>
                <img
                  className="d-block w-100 carousel-img"
                  src={img1}
                  alt="First slide"
                />
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100 carousel-img"
                  src={img2}
                  alt="Second slide"
                />
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100 carousel-img"
                  src={img3}
                  alt="Third slide"
                />
              </Carousel.Item>
            </Carousel>
          </div>

          {/* Language + Menu */}
      
        </Container>
      </Navbar>

      {/* 🔹 Desktop Navbar */}
      <Navbar expand="sm" className="desktop-navbar bg-white shadow-sm" sticky="top">
        <Container>
        <h1 className="mt-3 navbarHeading">Falcon Star Stamps</h1>
          <Nav className={`ms-auto ${language === "ARR" ? "rtl-nav" : ""}`}>
            {sections.map((section) => (
              <Nav.Link
                key={section.id}
                href={`#${section.id}`}
                className={activeSection === section.id ? "active" : ""}
                  style={{
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "16px",
                      fontWeight: activeSection === section.id ? "600" : "500",
                      color: activeSection === section.id ? "#ff6600" : "#333",
                      textTransform: "capitalize",
                      transition: "color 0.3s ease",
                      whiteSpace: "nowrap",
                      textAlign:"center"
                    }}
              >
                {section.label}
              </Nav.Link>
            ))}
             <Button className="lang-btn" onClick={toggleLanguage}>
              {language}
            </Button>
          </Nav>
        </Container>
      </Navbar>

      {/* 🔹 Mobile Menu */}
      <div className={`mobile-menu ${isOpen ? "open" : ""}`}>
        <button className="close-btn" onClick={closeMenu}>
          ✕
        </button>
        <nav
          className={`mobile-nav d-flex flex-column align-items-center ${
            language === "ARR" ? "rtl-nav" : ""
          }`}
        >
          <h4 className="mb-4">{t("Falcon Star Stamps")}</h4>
          {sections.map((section) => (
            <a
              key={section.id}
              href={`#${section.id}`}
              className={activeSection === section.id ? "active" : ""}
              onClick={closeMenu}
            >
              {section.label}
            </a>
          ))}
        </nav>
      </div>
    </>
  );
}

export default Navigation;